<template>
  <div class="home-pendant" v-if="isShowIndexAD && yhPCFloatTopList.length>0 && yhPCFloatLeftList.length>0 && yhPCFloatRightList.length>0 && yhPCFloatQrList.length>0" >
    <div class="home-popBox">
      <i class="close-btn"
         @click="CLOSE_INDEX_AD"></i>
      <div class="header" v-if="yhPCFloatTopList.length>0" :style="{'background-image': 'url('+yhPCFloatTopList[0].imgLink+')'}"></div>
      <div class="content" v-if="yhPCFloatLeftList.length>0||yhPCFloatRightList.length>0||yhPCFloatQrList.length>0">
        <div class="left-nav-wrap">
          <ul class="left-nav" v-if="yhPCFloatLeftList.length>0">
            <li @mouseover="setMiddleImgIndex(index)"
                :class="{'left-nav-active': index === middleImgIndex}"
                v-for="(item,index) in yhPCFloatLeftList"
                :key="item.id">
              <span>{{item.imgName}}</span>
            </li>
          </ul>
          <div class="qr" v-if="yhPCFloatQrList.length>0">
            <img :src="yhPCFloatQrList[0].imgLink" alt="">
          </div>
        </div>
        <div class="right-content-wrap">
          <el-container>
            <el-main style="padding: 10px">
              <div class="middle-img-wrap" v-if="yhPCFloatLeftList.length>0">
                  <div class="middle-img-item"
                       v-if="index===middleImgIndex"
                       v-for="(item,index) in yhPCFloatLeftList"
                       :key="item.id">
                    <a v-if="item.imgClickLink" target="_blank" @click.prevent="goHref(item.imgClickLink)" href="#">
                      <div>
                        <p>{{item.remark}}</p>
                        <img :src="item.imgLink" alt="">
                      </div>
                    </a>
                    <div v-if="!item.imgClickLink">
                      <p>{{item.remark}}</p>
                      <img :src="item.imgLink" alt="">
                    </div>
                  </div>
              </div>
            </el-main>
            <el-aside width="223px">
              <ul class="right-img-wrap" v-if="yhPCFloatRightList.length>0">
                <li v-for="(item) in yhPCFloatRightList" :key="item.id">
                  <a v-if="item.imgClickLink" target="_blank" @click.prevent="goHref(item.imgClickLink)" href="#">
                    <img :src="item.imgLink" alt="">
                  </a>
                  <img  v-if="!item.imgClickLink" :src="item.imgLink" alt="">
                </li>
              </ul>
            </el-aside>
          </el-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
  import {mapMutations,mapState} from 'vuex'
  import {commonApi, common} from '@/common/index';

export default {
  name: 'home-pendant',
  data() {
    return {
      imgList: [],
      middleImgIndex: 0,

      yhPCFloatTopList: [],
      yhPCFloatLeftList: [],
      yhPCFloatRightList: [],
      yhPCFloatQrList: [],
    }
  },
  computed: {
    ...mapState({
      isShowIndexAD: state => state.isShowIndexAD,
    })
  },
  methods: {
    ...mapMutations([
      'CLOSE_INDEX_AD'
    ]),
    setMiddleImgIndex(index) {
      this.middleImgIndex = index
    },
    fetchImg() {
      // let yhPCFloatTop = commonApi.HOMEBEFORE.fetchImg('yhPCFloatTop');
      // let yhPCFloatLeft = commonApi.HOMEBEFORE.fetchImg('yhPCFloatLeft');
      // let yhPCFloatRight = commonApi.HOMEBEFORE.fetchImg('yhPCFloatRight');
      // let yhPCFloatQr = commonApi.HOMEBEFORE.fetchImg('yhPCFloatQr');

      // Promise.all([yhPCFloatTop, yhPCFloatLeft, yhPCFloatRight, yhPCFloatQr])
      //   .then(data => {
      //     this.yhPCFloatTopList = data[0];
      //     this.yhPCFloatLeftList = data[1];
      //     this.yhPCFloatRightList = data[2];
      //     this.yhPCFloatQrList = data[3]
      //   })
      //   .catch(err=>{
      //     this.imgList = []
      //   })
        let imgCodes = ['yhPCFloatTop','yhPCFloatLeft','yhPCFloatRight','yhPCFloatQr'].join(',')
         commonApi.HOMEBEFORE.fetchImgs(imgCodes)
         .then((data)=>{
          this.yhPCFloatTopList = data.yhPCFloatTop;
          this.yhPCFloatLeftList = data.yhPCFloatLeft;
          this.yhPCFloatRightList = data.yhPCFloatRight;
          this.yhPCFloatQrList = data.yhPCFloatQr;
         })

    },
    goHref(url) {
      let path = common.goHref(url);
      if(path) {
        this.$router.push({path: path})
      }
    }
  },
  mounted() {
    this.fetchImg()
  }
};
</script>

<style scoped lang="scss">
  @import '../../style/variable';
.home-pendant{position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,.8);z-index: 9999;text-align: center;
  .home-popBox{position: fixed;z-index: 2201;top: 50%;width: 1002px;text-align: center;left: 50%;transform: translate(-50%,-50%);
    .close-btn{display: block;cursor: pointer;position: absolute;top: 82px;right: 5px;z-index: 1;width: 54px;height: 54px;background: url('./img/close.png') no-repeat center top;}
    .header{height: 191px;background-repeat: no-repeat;background-size: cover;background-position: center center}
    .content{height: 441px;background: url('./img/pop_bg.png') no-repeat center bottom;padding-top: 2px;background-size: 100% 100%;

      .left-nav-wrap{width: 160px;float: left;
        .left-nav{
          li{width: 158px;cursor: pointer;position: relative;font-size: 14px;color: #fff;border: 1px solid #9e9459;border-top: none;
            span{display: inline-block;position: relative;z-index: 3;vertical-align: top;width: 100%;height: 43px;line-height: 43px;padding: 0 10px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
            &:before{content: none;position: absolute;z-index: 0;display: block;width: 167px;height: 43px;left: 0;top: 0;background: url("./img/item-bg.png") no-repeat left center;background-size: 100% 100%}
            &:hover{border-right: none;color: $nav-font;font-weight: bolder;
              &:before{content: ''}
            }
          }
          .left-nav-active{border-right: none;color: $nav-font;font-weight: bolder;
            &:before{content: ''}
          }
        }

        .qr{padding-top: 3px;text-align: center;
          img{width: 158px;height: 201px;}
        }
      }
      .right-content-wrap{margin-left: 160px;padding-top: 2px;
        .middle-img-wrap{
          .middle-img-item{
            p{height: 28px;text-align: center;color: #fff;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
            img{width: 600px;height: 389px}
          }
        }
        .right-img-wrap{padding-top: 8px;
          li{padding: 10px 0;text-align: left;
            img{width: 210px;height: 120px}
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/pendant/home-pendant.vue